module.exports = __webpack_public_path__ + "static/img/3s-info-b4.78c2e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-info-b4.png
// module id = UPrL
// module chunks = 0